import { action, extendObservable } from 'mobx';
import { apiFetchGet, apiFetchPost } from '../helpers/api';
import {
    GET_VOTE,
    VOTE_OPEN,
    VOTE_PENDING,
    CAST_VOTE,
    DOC_TYPE_VOTE,
    PERM_VOTE_VOTE,
    RESPONSE_VOTING_AUTHORISATION,
    LIST_GROUP_VOTES
} from '../helpers/constants';
import _ from 'lodash';
import store from './store';

export default class VoteStore {
    constructor(factory) {
        this.factory = factory;
        this.validDocuments = [];

        extendObservable(this, {
            data: {
                companies: {},
            },
            dataFilteredByHierarchy: [],
            shouldDisplayVoteTab: false,
            init: true,
            loading: true,
            selectedId: null,

            set: action((field, value) => {
                this[field] = value;                
            }),

            setVotes: action('setVotes', (instanceId, json) => {
                this.loading = true;
                const votes = json.VotingList;
                const groups = {};
                let arrValidDocuments = [];

                votes.forEach(vote => {
                    vote.InstanceId = instanceId;
                    if (!groups.hasOwnProperty(vote.GroupId)) {
                        groups[vote.GroupId] = { [vote.VoteId]: vote };
                    } else {
                        groups[vote.GroupId][vote.VoteId] = vote;
                    }

                    //build the valid doc key list ready to clean indexedDB
                    if (window.offlineApiExtension) {
                        vote.VotingDocs.forEach(function(document) {
                            const docKey = store.documents.buildDocKey(
                                DOC_TYPE_VOTE,
                                instanceId,
                                document.VoteDocId,
                            );
                            arrValidDocuments.push({ docKey });
                        });
                    }
                });

                this.data.companies[instanceId] = groups;

                this.loading = false;
                this.refreshShouldDisplayVoteTab();
                if (this.init) {
                    this.factory.groups.setVisualIndicatorsToGroupsAndCompanies();
                    this.init = false;
                }

                if (window.offlineApiExtension) {
                    if (arrValidDocuments.length > 0) {
                        this.validDocuments = this.validDocuments.concat(arrValidDocuments);
                    }
                }
            }),

            select: action('select', id => {
                this.selectedId = id;
            }),

            setShouldDisplayVoteTab: action('setShouldDisplayVoteTab', shouldDisplayVoteTab => {
                this.shouldDisplayVoteTab = shouldDisplayVoteTab;
            }),

            toggleFilter: action('toggleFilter', filterSelected => {
                this.filter = filterSelected;
            }),

            refreshShouldDisplayVoteTab: () => {
                this.setShouldDisplayVoteTab(this.filterVotesByCurrentHierarchy().length !== 0);
            },

            filterVotesByFilter: (votes, filter) => {
                return votes.filter(vote => {
                    return vote.VoteStatus === filter;
                });
            },

            filterVotesByCurrentHierarchy: () => {
                const votesFilteredByHierarchy = [];
                const selectedCompany = this.factory.companies.selectedId;
                const selectedGroup = this.factory.groups.selectedId;
                const companies = this.data.companies;

                if (selectedCompany === null) {
                    for (const key in companies) {
                        if (companies.hasOwnProperty(key)) {
                            votesFilteredByHierarchy.push(...this.votesFilteredByCompany(key));
                        }
                    }
                } else if (selectedGroup === null) {
                    votesFilteredByHierarchy.push(...this.votesFilteredByCompany(selectedCompany));
                } else {
                    //if(this.votesFilteredByGroup(selectedCompany, selectedGroup) !== null)
                    votesFilteredByHierarchy.push(
                        ...this.votesFilteredByGroup(selectedCompany, selectedGroup),
                    );
                }

                this.dataFilteredByHierarchy = votesFilteredByHierarchy;
                return votesFilteredByHierarchy;
            },

            filterVotesByCurrentHierarchyAndFilter: filter => {
                return this.dataFilteredByHierarchy.filter(vote => {
                    return vote.VoteStatus === filter;
                });
            },

            fetchVotesFromCompanies: companyList => {
                this.validDocuments = [];

                if (typeof companyList !== 'undefined') {
                    return Promise.all(
                        companyList.map((company, index) => {
                            if (company) {
                                
                               /* OLD CODE return apiFetchGet(GET_VOTE, this.factory.user.token, {
                                    instanceId: company.InstanceId,
                                }).then(json => {
                                    if (json !== null) {
                                        this.setVotes(company.InstanceId, json);
                                    }
                                }); */
                                
                                return this.fetchVotesFromCompanyGroups(this.factory.user.token, company).then(json => {
                                    this.setVotes(company.InstanceId, json);
                                    return json;                                    
                                 });
                            } else {
                                return null;
                            }
                            // return null;
                        }),
                    ).then(() => {
                        if (window.offlineApiExtension) {
                            window.offlineApiExtension.cleanIdbContent_Documents(
                                store.documents.buildCompareString(DOC_TYPE_VOTE),
                                this.validDocuments,
                            );
                        }
                    });
                }
            },

            fetchVotesFromCompanyGroups: async (token, company) => {
                var votingJson = {};
                await Promise.all(
                    company.Groups.map(async (item, y) => {
                        if (item) {

                            const json = await apiFetchGet(LIST_GROUP_VOTES, token, {
                                    instanceId: company.InstanceId,
                                    groupId:    item.GroupId
                                }).then(json => {
                                    return json;
                                });

                             if(!votingJson.hasOwnProperty('VotingList')) {
                                votingJson = Object.assign(votingJson, json);
                             } else {
                                 let tmpVotes = votingJson.VotingList;
                                 var attributes = Object.keys(json.VotingList)
                                 for (var i = 0; i < attributes.length; i++) {
                                    tmpVotes.push(json.VotingList[attributes[i]]);
                                }
                                votingJson.Votes = tmpVotes;
                            }

                            //console.log(company.InstanceId, item.GroupId, {votingJson});
                            return votingJson;
                        } else {
                            return {};
                        }
                    })
                ).then(res => {
                    return votingJson;
                });
                return votingJson;
            },

            fetch: async () => {
                const companyList = this.factory.companies.data.Companies;
                return await this.fetchVotesFromCompanies(companyList);
            },

            votesFilteredByCompany: companyId => {
                const votesFilteredByCompany = [];
                const company = this.data.companies[companyId];
                for (const key in company) {
                    if (company.hasOwnProperty(key)) {
                        if (company[key] != null) {
                            votesFilteredByCompany.push(...Object.values(company[key]));
                        }
                    }
                }

                return votesFilteredByCompany;
            },

            votesFilteredByGroup: (companyId, groupId) => {
                // if(this.data.companies[companyId] != null
                //     && this.data.companies[companyId].length > 0) {
                const group = _.get(this.data.companies, `${companyId}.${groupId}`, null);

                const votesFilteredByGroup = [];
                if (group != null) {
                    votesFilteredByGroup.push(...Object.values(group));
                }

                return votesFilteredByGroup;
                // }

                // return null;
            },

            newVoteCount: () => {
                return this.filterVotesByCurrentHierarchyAndFilter(VOTE_OPEN).filter(vote => {
                    return (
                        (vote.VotePermissions & PERM_VOTE_VOTE) === PERM_VOTE_VOTE &&
                        vote.CurrentCastVote === VOTE_PENDING
                    );
                }).length;
            },

            castVote: async (InstanceId, GroupId, VoteId, VoteCast) => {
                let params = {
                    InstanceId,
                    VoteId,
                    VoteCast,
                };

                await apiFetchPost(CAST_VOTE, this.factory.user.token, params);
                await this.fetch();
                store.groups.resetVisualIndicatorsForGroup(InstanceId, GroupId);
            },

            /**
             * user respond to Authorisation
             * @param InstanceId
             * @param GroupId
             * @param MeetingId
             * @param AuthorisationId
             */
            responseAuthorisation: async (InstanceId, GroupId, VoteId, AuthorisationId) => {
                let params = {
                    InstanceId,
                    GroupId,
                    VoteId,
                    AuthorisationId,
                };
                await apiFetchPost(RESPONSE_VOTING_AUTHORISATION, this.factory.user.token, params);
                await this.fetch();
                store.groups.resetVisualIndicatorsForGroup(InstanceId, GroupId);
            },

            getNumberOfNewVotesPerGroup(companyId, groupId) {
                return store.votes.votesFilteredByGroup(companyId, groupId).filter(vote => {
                    return (
                        (vote.VotePermissions & PERM_VOTE_VOTE) === PERM_VOTE_VOTE &&
                        vote.CurrentCastVote === VOTE_PENDING
                    );
                }).length;
            },

            get selectedVote() {
                if (this.selectedId !== null) {
                    return this.dataFilteredByHierarchy.filter(
                        vote => (vote.VoteId === this.selectedId ? vote : null),
                    );
                }
                return null;
            },
        });
    }
}



// WEBPACK FOOTER //
// ./src/stores/VoteStore.js